import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  title: {
    textAlign: 'center',
    fontWeight: 600,
  },
  subtitle: { textAlign: 'center' },
}));

export default function DialogHeader({
  title,
  subtitle = null,
  className = '',
}) {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h6" className={`${classes.title} ${className}`}>
        {title}
      </Typography>
      {subtitle && (
        <Typography className={classes.subtitle}>{subtitle}</Typography>
      )}
    </>
  );
}
